<script lang="ts">
	// import * as Icon from '$lib/components/icons/index.js';
	import { mode } from '$lib/state/global.svelte';
	import ModeToggle from '$lib/components/mode-toggle.svelte';
	//import CommandMenu from '$lib/components/command-menu.svelte';
	import MainNav from '$lib/components/nav/main-nav.svelte';
	import MobileNav from '$lib/components/nav/mobile-nav.svelte';
	import { buttonVariants } from '$lib/components/ui/button';
	import { siteConfig } from '$lib/config/site.js';
	import { cn } from '$lib/utils.js';
	import BookDemo from '$lib/components/book-demo.svelte';
	import { bookDemoState, bookDemo } from '$lib/state/global.svelte';

	let { navigation } = $props();
</script>

<header
	class="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
>
	<BookDemo bind:open={bookDemoState.open} />
	<div class="container flex h-14 max-w-screen-lg items-center justify-between px-4">
		<div class="flex">
			<a href="/" class="mr-6 flex items-center space-x-2 max-sm:mr-0">
				{#if $mode === 'dark'}
					<img alt="MVMNT" src={siteConfig.darkLogo} class="w-[140px]" />
				{:else}
					<img alt="MVMNT" src={siteConfig.lightLogo} class="w-[140px]" />
				{/if}
			</a>
			<MainNav {navigation} />
		</div>
		<div class="flex items-center justify-end justify-between gap-x-2">
			<!-- <div class="w-full flex-1 md:w-auto md:flex-none"> -->
			<!-- 	<CommandMenu /> -->
			<!-- </div> -->
			<nav class="flex items-center gap-x-2">
				<a
					href={siteConfig.links.login}
					target="_blank"
					rel="noopener noreferrer"
					class="max-md:hidden"
				>
					<div
						class={cn(
							buttonVariants({
								size: 'sm',
								variant: 'ghost'
							}),
							''
						)}
					>
						<!-- <Icon.GitHub class="size-4" /> -->
						<span class="">Login</span>
					</div>
				</a>
				<button onclick={bookDemo} class="max-sm:hidden">
					<div
						class={cn(
							buttonVariants({
								size: 'sm',
								variant: 'outline'
							}),
							''
						)}
					>
						<!-- <Icon.GitHub class="size-4" /> -->
						<span class="">Get a demo</span>
					</div>
				</button>
				<a href={siteConfig.links.signup} rel="noopener noreferrer" class="max-sm:hidden">
					<div
						class={cn(
							buttonVariants({
								size: 'sm'
								// variant: 'ghost'
							}),
							''
						)}
					>
						<!-- <Icon.Twitter class="size-3 fill-current" /> -->
						<span class="">Start for free</span>
					</div>
				</a>
				<div class="flex md:hidden">
					<MobileNav {navigation} />
				</div>
				<ModeToggle />
			</nav>
		</div>
	</div>
</header>
